import clsx from "clsx"
import {useEffect, useRef} from "react"
import {VideoSource} from "~/types/VideoSource"

import "./MobileVideoPlayer.css"

interface MobileVideoPlayerProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "onPause"> {
    videoSources: Array<VideoSource> | VideoSource
    videoClass?: string | undefined
    videoStyle?: React.CSSProperties | undefined
    pauseVideo?: boolean
}

const MobileVideoPlayer: React.FC<MobileVideoPlayerProps> = props => {
    const {className, pauseVideo = false, videoClass, videoStyle, videoSources, ...otherProps} = props
    const videoRef = useRef<HTMLVideoElement | null>(null)

    useEffect(() => {
        if (pauseVideo) {
            videoRef.current?.pause()
        } else {
            videoRef.current?.play()
        }
    }, [pauseVideo])

    return (
        <div className={clsx("mobile-video-player-k6zm", "visible-k6zm", className)} {...otherProps}>
            <div className="mobile-frame-k6zm">
                <video
                    className={clsx("video-k6zm", videoClass)}
                    autoPlay
                    loop
                    muted
                    playsInline
                    ref={videoRef}
                    style={videoStyle}
                >
                    {[videoSources].flat().map((source, index) => {
                        if (!source.src || !source.mimeType) return
                        return <source src={source.src} type={source.mimeType} key={index} />
                    })}
                </video>
            </div>
        </div>
    )
}

export default MobileVideoPlayer
